import { axiosClient } from "utilz";
import { apiErrorHandler } from "utilz/helpers";

/**
 * Records that the current user wants access to a gated feature.
 *
 * `msp_id` and `resource_id` come from the auth token — never send them.
 * The call is an upsert: asking again for the same feature is not an error,
 * it just bumps `updated_at` on the existing row.
 *
 * Relative URL, so it goes to the default host like the other tenant-level
 * routes (e.g. feature flags).
 */
export const createAccessRequest = async (featureName: string) => {
  // Guard, not politeness: a blank or non-string feature_name does not return
  // the documented 400 — it kills the service process, and every other route
  // with it (verified on UAT, 2026-09-04). Never let one reach the wire.
  if (typeof featureName !== "string" || featureName.trim() === "") {
    throw new Error("featureName is required");
  }
  try {
    const url = "v1/access-requests";
    const response = await axiosClient.post(url, { feature_name: featureName });
    const resData = response.data;
    if (resData?.success && resData?.statusCode === 200) {
      return resData?.data;
    }
    throw response;
    // biome-ignore lint/suspicious/noExplicitAny: apiErrorHandler takes the raw axios error
  } catch (error: any) {
    apiErrorHandler(error);
  }
};
